import { useMutation, mutationOptions, useQueryClient } from '@tanstack/react-query';

import { startCompanyAnalysis } from '../../api/companyAnalysisApi';
import { jobKeys } from '../jobs/keys';

import { companyAnalysisKeys, companyAnalysisMutationKeys } from './keys';

export const startCompanyAnalysisOptions = (queryClient) =>
	mutationOptions({
		mutationKey: companyAnalysisMutationKeys.start,
		mutationFn: startCompanyAnalysis,
		onSuccess: () => {
			// Invalidate job queries to show the new analysis job
			queryClient.invalidateQueries({ queryKey: jobKeys.all });
			// Invalidate AI analysis queries to refresh scores when job completes
			queryClient.invalidateQueries({ queryKey: companyAnalysisKeys.all });
		},
	});

export function useStartCompanyAnalysis() {
	const queryClient = useQueryClient();
	return useMutation(startCompanyAnalysisOptions(queryClient));
}
